import React, { Component } from 'react'
import ContMessageI18N from "../../containers/ContMessageI18N";
import NumberFormatCustom from '../std/NumberFormatCustom';
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min";
import HelperGenerics from '../../helpers/HelperGenerics';

class AmountOtrText extends Component {
	constructor(props) {
		super(props);
		this.state = { ...AmountOtrText.getStateFromProps(props) };
		this.getLabel = this.getLabel.bind(this);
	}

	componentDidMount() {
            const tooltipTriggerNode = document.querySelector(`#v_${HelperGenerics.rebuildWord(this.props.configurationKey)}_${this.props.fieldname}_check_tooltip`);
			new bootstrap.Tooltip(tooltipTriggerNode);
    }

	static getStateFromProps(props) {
		return {
			amountInclTax: props.amountInclTax,
			amountExclTax: props.amountExclTax,
			otrIncluded: props.otrIncluded,
			notTaxable: props.notTaxable
		}
	}

	static getDerivedStateFromProps(props, currentState) {
		if (currentState.otrIncluded !== props.otrIncluded
			|| currentState.amountInclTax !== props.amountInclTax
			|| currentState.amountExclTax !== props.amountExclTax
		) {
			return AmountOtrText.getStateFromProps(props);
		}
		return null
	}

	getLabel(suffix) { return this.props.developperView ? this.props.fieldname + suffix : this.getMessage(this.props.labelPrefix + this.props.fieldname + suffix); }


	getMessage(i18nKey, prefix, optionValue, callBackText) {
		return <ContMessageI18N i18n={i18nKey} prefix={prefix} optionValue={optionValue} callBackText={callBackText} />
	}

	retrieveMessageStr(i18nKey) {
		return this.getMessage(i18nKey, null, null, (text) => {
			this.messageStrToolTip = text;
		});
	}

	render() {
		const notTaxable = Boolean(this.state.notTaxable);
		return (
			<React.Fragment>
				<div className="card" >
					<div className="card-body">
						<div className="row">
							<div className="col-auto form-floating">
								<NumberFormatCustom id={ `${HelperGenerics.rebuildWord(this.props.configurationKey)}_${this.props.fieldname}InclTax`}
									className="form-control"
									placeholder={this.props.developerView ? `${this.props.fieldname} amountInclTax` : this.getLabel('InclTax')}
									value={this.state.amountInclTax != null ? this.state.amountInclTax : ''}
									onChange={this.props.handleChange(`${this.props.fieldname}InclTax`)} />
								<label htmlFor={`${this.props.fieldname}InclTax`}>
									{this.props.developerView ? `${this.props.fieldname} amountInclTax` : this.getLabel('InclTax')}
								</label>
							</div>
							{!notTaxable && <div className="col-auto form-floating">
								<NumberFormatCustom id={ `${HelperGenerics.rebuildWord(this.props.configurationKey)}_${this.props.fieldname}ExclTax`} className="form-control"
									placeholder={this.props.developerView ? `${this.props.fieldname} amountExclTax`
										: this.getLabel('ExclTax')}
									value={this.state.amountExclTax != null ? this.state.amountExclTax : ''}
									onChange={this.props.handleChange(`${this.props.fieldname}ExclTax`)} />
								<label htmlFor={`${this.props.fieldname}ExclTax`}>
									{this.props.developerView ? `${this.props.fieldname} amountExclTax` : this.getLabel('ExclTax')}
								</label>
							</div>
							}
							<div className="col-auto form-check" tabIndex="0"
								data-bs-toggle="tooltip" data-bs-placement="top" title={this.messageStrToolTip}
								data-bs-title={this.messageStrToolTip}
								id={ `v_${HelperGenerics.rebuildWord(this.props.configurationKey)}_${this.props.fieldname}_check_tooltip`}>
								<input className="form-check-input" type="checkbox" value={this.state.otrIncluded}
									id={`v_${HelperGenerics.rebuildWord(this.props.configurationKey)}_${this.props.fieldname}OtrIncluded`}
									onChange={this.props.handleChange(`${this.props.fieldname}OtrIncluded`)}/>
								<label className="form-check-label" htmlFor={`v_${HelperGenerics.rebuildWord(this.props.configurationKey)}_${this.props.fieldname}OtrIncluded`}>
									{this.getMessage('generics.otr.checkbox.label')}
								</label>
								<span style={{ display: 'none' }}>{this.retrieveMessageStr('generics.otr.checkbox.popup')}</span>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

export default (AmountOtrText)
